// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"d5473c59","152":"9473e69e","169":"6807b3bb","488":"192d5731","505":"24eeb4a4","517":"8be08d4b","631":"b065e940","928":"9cd84e10"}[chunkId] + ".chunk.js";
};